import { RouteRecordRaw } from 'vue-router';
import { useUserData } from '@/lib/mypage/useMypage';

import App from '@/App.vue';
import FrameMypage from '@/components/FrameMypage.vue';
import FrameUnit from '@/components/FrameUnit.vue';
import Home from '@/views/Home.vue';
import Layout from '@/components/Layout.vue';
/*

    메인 라우터

*/
const routerHome: RouteRecordRaw = {
  path: '/',
  name: 'router.home',
  component: Layout,
  children: [
    {
      path: '',
      component: Home,
    },
  ],
};

/*

  서비스 소개 라우터

*/
const routerService: RouteRecordRaw = {
  path: '/service',
  name: 'router.service',
  component: Layout,
  children: [
    {
      path: '',
      name: 'router.service-service',
      component: () => import('@/views/business/Service.vue'),
    },
  ],
};

/*

    주문접수 라우터

*/
const routerOutbound: RouteRecordRaw = {
  path: '/outbound',
  name: 'router.outbound',
  redirect: '/outbound/complete',
  component: Layout,
  meta: {
    requireAuth: true,
  },
  children: [
    {
      path: 'quick',
      name: 'router.outbound-quick',
      component: () => import('@/views/outbound/Quick.vue'),
    },
    {
      path: 'parcel',
      name: 'router.outbound-parcel',
      component: () => import('@/views/outbound/Parcel.vue'),
    },
    {
      path: 'mass-parcel',
      name: 'router.outbound-mass-parcel',
      component: () => import('@/views/outbound/MassParcel.vue'),
    },
    {
      path: 'registry',
      name: 'router.outbound-registry',
      component: () => import('@/views/outbound/Registry.vue'),
    },
    {
      path: 'mass-registry',
      name: 'router.outbound-mass-registry',
      component: () => import('@/views/outbound/MassRegistry.vue'),
    },
    {
      path: 'global',
      name: 'router.outbound-global',
      component: () => import('@/views/outbound/GlobalMail.vue'),
    },
    {
      path: 'complete',
      name: 'router.outbound-complete',
      component: () => import('@/views/outbound/Complete.vue'),
    },
    {
      path: 'app-menu',
      name: 'router.outbound-menu',
      component: () => import('@/views/outbound/AppMenu.vue'),
    },
  ],
};

/*

    배송조회 라우터

*/
const routerTracking: RouteRecordRaw = {
  path: '/tracking',
  name: 'router.tracking',
  redirect: '/tracking/outbound',
  meta: {
    requireAuth: true,
  },
  component: Layout,
  children: [
    {
      path: 'outbound',
      name: 'router.tracking-outbound',
      component: () => import('@/views/tracking/Outbound.vue'),
    },
    {
      path: 'outbound-detail',
      name: 'router.tracking-outbound-detail',
      component: () => import('@/views/tracking/OutboundDetail.vue'),
    },
    {
      path: 'inbound',
      name: 'router.tracking-inbound',
      component: () => import('@/views/tracking/Inbound.vue'),
    },
    {
      path: 'inbound-detail',
      name: 'router.tracking-inbound-detail',
      component: () => import('@/views/tracking/InboundDetail.vue'),
    },
  ],
};

/*

    고객지원 라우터

*/
const routerHelp: RouteRecordRaw = {
  path: '/help',
  name: 'router.help',
  redirect: '/help/notice',
  component: Layout,
  children: [
    {
      path: 'notice',
      name: 'router.help-notice',
      component: () => import('@/views/help/Notice.vue'),
    },
    {
      path: 'faq',
      name: 'router.help-faq',
      component: () => import('@/views/help/Faq.vue'),
    },
  ],
};

/**
 * 고객혜택 라우터
 */
const routerBenefit: RouteRecordRaw = {
  path: '/client',
  name: 'router.benefit',
  component: Layout,
  children: [
    {
      path: 'benefit',
      name: 'router.benefit.child',
      component: () => import('@/views/client/Benefit.vue'),
    },
  ],
};

/*

    마이페이지 라우터

*/
const routerMypage: RouteRecordRaw = {
  path: '/mypage',
  name: 'router.mypage',
  redirect: '/mypage/profile',
  beforeEnter: async () => {
    const { setupUserData } = useUserData();
    await setupUserData();
  },
  component: FrameMypage,
  meta: {
    requireAuth: true,
  },
  children: [
    {
      path: 'profile',
      name: 'router.mypage-profile',
      component: () => import('@/views/mypage/Profile.vue'),
    },
    {
      path: 'billing',
      name: 'router.mypage-billing',
      component: () => import('@/views/mypage/Billing.vue'),
    },
    {
      path: 'unit',
      name: 'router.mypage-unit',
      component: FrameUnit,
      children: [
        {
          path: 'admin-host-unit-info',
          name: 'router.mypage-unit-admin-sub.admin-host-unit-info',
          component: () => import('@/views/unit/UnitGroupInfo.vue'),
        },
        {
          path: 'admin-unit-member-info',
          name: 'router.mypage-unit-admin-sub.admin-unit-member-info',
          component: () => import('@/views/unit/UnitMember.vue'),
        },
        {
          path: 'admin-host-unit-approve',
          name: 'router.mypage-unit-admin-sub.admin-host-unit-approve',
          component: () => import('@/views/unit/UnitApprove.vue'),
        },
        {
          path: 'admin-host-unit-history',
          name: 'router.mypage-unit-admin-sub.admin-host-unit-history',
          component: () => import('@/views/unit/UnitUseHistory.vue'),
        },
        {
          path: 'unit-group-detail',
          name: 'router.mypage-unit-admin-sub.unit-group-detail',
          component: () => import('@/views/unit/UnitGroupDetail.vue'),
        },
        {
          path: 'unit-member-detail',
          name: 'router.mypage-unit-admin-sub.unit-member-detail',
          component: () => import('@/views/unit/UnitMemberDetail.vue'),
        },
        {
          path: 'unit-member-register',
          name: 'router.mypage-unit-admin-sub.unit-member-register',
          component: () => import('@/views/unit/UnitMemberRegister.vue'),
        },
      ],
    },
  ],
};

/*

  로그인 라우터

*/
const routerSignin: RouteRecordRaw = {
  path: '/signin',
  name: 'router.signin',
  component: Layout,
  children: [
    {
      path: '',
      name: 'router.signin.child',
      component: () => import('@/views/sign/Signin.vue'),
    },
    {
      path: 'sso',
      name: 'router.sso',
      component: () => import('@/views/sign/Sso.vue'),
    },
  ],
};

/*

  회원가입 라우터

*/
const routerSignup: RouteRecordRaw = {
  path: '/signup',
  name: 'router.signup',
  component: Layout,
  children: [
    {
      path: '',
      name: 'router.signup.child',
      component: () => import('@/views/sign/Signup.vue'),
    },
    {
      path: 'info',
      name: 'router.signup-info',
      component: () => import('@/views/sign/SignupInfo.vue'),
    },
    {
      path: 'account-register',
      name: 'router.invite-email-signup',
      component: () => import('@/views/sign/InviteEmailSignup.vue'),
    },
    {
      path: 'account-denied',
      name: 'router.invite-email-denied',
      component: () => import('@/views/sign/InviteEmailDenied.vue'),
    },
  ],
};

/*
  SSO 라우터
  callback URL /:vendor
  - HYBE : vendor ?code=
  - IFC : vendor ?next=&token=
*/
const routerSSO: RouteRecordRaw = {
  path: '/sso/callback/:vendor',
  name: 'router.sso-callback',
  component: () => import('@/views/sign/SsoCallback.vue'),
};

const routerCallback: RouteRecordRaw = {
  path: '/callback-policy',
  name: 'router.callback-policy',
  component: () => import('@/views/sign/SsoCallbackPolicy.vue'),
};

/*

  oauth 라우터

*/
const routerOauth: RouteRecordRaw = {
  path: '/oauth',
  name: 'router.ouath',
  redirect: '/',
  component: App,
  children: [
    {
      path: 'naver',
      name: 'router.oauth-naver',
      component: () => import('@/views/oauth/Naver.vue'),
    },
    {
      path: 'kakao',
      name: 'router.oauth-kakao',
      component: () => import('@/views/oauth/Kakao.vue'),
    },
  ],
};

const routerNotFound: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: Layout,
  children: [
    {
      path: '',
      name: 'NotFoundChild',
      component: () => import('@/views/404.vue'),
    },
  ],
};

export {
  routerHome,
  routerOutbound,
  routerTracking,
  routerHelp,
  routerMypage,
  routerSignin,
  routerSignup,
  routerOauth,
  routerSSO,
  routerCallback,
  routerService,
  routerBenefit,
  routerNotFound,
};
